import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQueryForRTKQuery } from "../../../utils/axios";

export const planningScreenAPI = createApi({
    reducerPath: "planningScreen",
    baseQuery: axiosBaseQueryForRTKQuery({
        extendedUrl: "",
    }),

    endpoints(builder) {
        return {
            mainData: builder.query({
                query: (body) => ({
                    url: "/planning-rollup",
                    method: "post",
                    data: body,
                }),
                providesTags: ["planning-rollup"],
                transformResponse: (res) => res.data.data,
            }),
        };
    },
});

export const { useLazyMainDataQuery } = planningScreenAPI;
